import React, {useState, useEffect} from 'react';
import * as R from 'ramda';
import {ColapsedView} from './colapsedView';
import {EditView} from './editView';
import Referent from '../../../../constants/models/referent';
import Address from '../../../../constants/models/address';

export const DossierReferents = ({referents, userId, isLoading}) => {

	const [referentList, setReferentList] = useState(referents.map((r) => {return {...r, isEditing: false}}));
	function toggleEditMode(referentId){
		setReferentList(referentList.map((r) => {
			if(r.id !== referentId){
				return r;
			}else{
				return {
					...r,
					isEditing: !r.isEditing
				}
			}
		}))
	}

	function removeFromList(referentId){
		setReferentList(referentList.filter((r) => r.id !== referentId));
	}
	
	useEffect(() => {
		setReferentList(referents.map((r) => {return {...r, isEditing: false}}));
	}, [referents])

	return (
		<article className="view-calc pt-4 mb-auto">
			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm alert alert-primary text-center sticky-top">
					<h1 className="text-primary font-weight-bolder mt-2 mb-2">Les référents</h1>
				</header>
			</div>
			<div className="auto-view pb-3 pb-lg-0 mb-lg-0">
				<div className="container-fluid">
					<div className="grid grid-md-base grid-xl-wide">
						{
							referentList.map((referent) => {
								if(R.isNil(referent))
									return ''

								return referent.isEditing === true ?
									<EditView referent={referent} key={referent.id} index={referent.id} updateReferent={undefined} toggleEditMode={toggleEditMode}  removeFromList={removeFromList}  userId={userId} isLoading={isLoading} />
								:
									<ColapsedView referent={referent} key={referent.id} toggleEditMode={toggleEditMode} userId={userId} />
							})
						}
						<div className="card card-body">
                                    <button 
                                        className={`btn btn-alert-info font-weight-bolder mb-3 py-2 ${referentList.findIndex(r => r.id === "new") > -1 ? "disabled btn-disabled" : ""}`} 
                                        role={"button"}
										disabled={referentList.findIndex(r => r.id === "new") > -1 ? true : false}
                                        onClick={() => {
											const newReferent = new Referent({id: "new", birthDate: undefined});
											newReferent.addresses = [new Address()];
											setReferentList([...referentList, {...newReferent, isEditing: true}])

										}}>
                                        <i className="eva lh-copy eva-person-add-outline mr-2 my-auto h3 lh-solid d-inline-block align-middle "></i> Ajouter un autre référent
                                    </button>
                                
                                    <p className="h5 o-80 font-weight-bold lh-copy mb-3 pb-2 ls-n1">IL EST FORTEMENT CONSEILLÉ DE RENSEIGNER AU MOINS 2 RÉFÉRENTS AFIN D’OPTIMISER VOTRE SERVICE.</p>
                                    {/* <p className="h5 o-50 lh-copy">Chaque référent sera averti par mail et message annuellement de votre démarche. <br />Au même titre, il n’aura pas accès aux informations de votre dossier (comptes bancaires, contrats d’assurance...).</p> */}
                                    
						</div>
					</div>
				</div>
			</div>
		</article>
	)
}